/* Sorting, denomination ordering, filter sheet
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 953-1002.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { typeLabel } from './community.js'
import { FILTER_DEFS, denomLabel, denomValue, filterNote, groupHasOptions, optionsFor } from './note-filters.js'
import { render } from './render.js'
import { $, cat, pubCat, save, state } from './state.js'

/* ---------- vault search / filters ---------- */
const SORTLABEL={added:"Order added",fr_asc:"Fr# low→high",fr_desc:"Fr# high→low",year_asc:"Year oldest",year_desc:"Year newest"};
const DENOM_ORDER=["3¢","5¢","10¢","15¢","25¢","50¢","$1","$2","$5","$10","$20","$50","$100","$500","$1,000","$5,000","$10,000"];const dord=d=>{const i=DENOM_ORDER.indexOf(d);return i<0?900:i;};
/* ⚠ The denomination ordering moved to `note-filters.js` so a gate can
 * reach it — it had never been tested. Re-exported below, so
 * `views-vault.js` imports it from here exactly as before. */
function frNum(fr){const m=(fr+"").match(/\d+/);return m?+m[0]:0;}
function noteYear(n){const m=((n&&n.desc)||"").match(/\b(1[7-9]\d\d)\b/);return m?+m[1]:null;}
function backfillYears(){let changed=false;state.collection.forEach(h=>{if(h.year===undefined){const n=cat(h.catId);const y=n?noteYear(n):null;h.year=y?String(y):"";changed=true;}});if(changed)save();}
/* ⚠ Only two groups relabel their values; the rest show them as the
 * catalogue states them, which is what a filter must match on. */
const LABEL_OF={type:typeLabel,denom:denomLabel};
function renderFilterSheet(){
  const ctx=state.fCtx||"vault";
  let items;
  /* ⚠⚠ `x.n ||` HERE FOR THE SAME REASON AS views-community.js:34, AND
   * LEAVING IT OUT WOULD HAVE BEEN WORSE THAN LEAVING BOTH ALONE.
   * This builds the Type and Denomination option lists. Fix only the
   * list and a stranger sees a "$100 · Federal Reserve" card with no
   * $100 in the denomination filter — the screen disagreeing with its
   * own filter sheet about which notes exist. The two sites resolve a
   * note the same way or they are a bug. */
  /* ⚠ Other's step 6: the options come from the notes the filters see — a
   * custom note's own year among them (`filterNote`, his ruling 7, his A and B). */
  if(ctx==="profile"){const p=(state.pubProfiles||[]).find(x=>x.username===state.viewUser)||{notes:[]};items=p.notes.map(x=>filterNote(pubCat(x),x.y)).filter(Boolean);}
  else items=state.collection.map(h=>filterNote(cat(h.catId),h.year));
  const cur=ctx==="profile"?state.pSort:state.vSort;
  const sortOpts=[["added","Order added"],["fr_asc","Fr# — low to high"],["fr_desc","Fr# — high to low"],["year_asc","Year — oldest first"],["year_desc","Year — newest first"]];
  /* ⚠ THE LABEL IS TEXT — his register item of 2026-09-27, built
   * 2026-10-04: on a profile the options come from a stranger's notes, so
   * a custom entry's `section` and `fd` (db/009) are labels here.
   * ⚠ AND THE VALUE IS ESCAPED LIKE THE FIFTEEN SITES BEFORE IT (the
   * cleanup round, 2026-10-09; the sixteenth site, found by the bundle's
   * `&quot;` count). `"` alone was escaped before; the tap handler reads
   * the attribute back as the value to filter by, so a value carrying `&`
   * or `<` read back changed and the tap filtered to nothing. */
  const escH=s=>String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  const opt=(on,val,lbl,attr)=>`<button class="opt ${on?"on":""}" data-${attr}="${escH(val)}">${String(lbl).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}</button>`;
  /* ⚠⚠ EVERY GROUP COMES FROM `FILTER_DEFS`, so the five filters cannot
   * drift apart — and ⚠⚠⚠ A GROUP WITH NO OPTIONS IS OMITTED ENTIRELY.
   * `charterPeriod` is on 386 of 11,614 catalogue rows, so a collector
   * with no National Bank Notes would otherwise see a heading over an
   * empty row. Type and Denomination are never empty, which is why the
   * sheet has never had to do this. */
  const groups=FILTER_DEFS.map(def=>{
    const opts=optionsFor(items,def);
    if(!groupHasOptions(items,def))return "";
    const now=state[ctx==="profile"?def.p:def.v]||"All";
    const attr="v"+def.key;
    const lbl=LABEL_OF[def.key]||(v=>v);
    return `<div class="grp"><div class="gl">${def.group}</div><div class="optrow">${opt(now==="All","All","All",attr)}${opts.map(v=>opt(now===v,v,lbl(v),attr)).join("")}</div></div>`;
  }).join("");
  $("filtersheet").innerHTML=`<div class="grip"></div>
    <h3>Filter &amp; sort</h3>
    <div class="grp"><div class="gl">Sort by</div><div class="optrow">${sortOpts.map(o=>opt(cur===o[0],o[0],o[1],"vsort")).join("")}</div></div>
    ${groups}
    <div class="sheetbtns"><button class="clear" data-clearfilters>Clear all</button><button class="done" data-closefilters>Done</button></div>`;
}
function openFilters(){renderFilterSheet();$("filtersheet").classList.add("open");$("filterscrim").classList.add("open");}
function closeFilters(){$("filtersheet").classList.remove("open");$("filterscrim").classList.remove("open");}
document.addEventListener("click",e=>{
  if(e.target.id==="filterscrim"){closeFilters();return;}
  /* ⚠⚠ EVERY FILTER'S ATTRIBUTE IS IN THIS ONE LIST. A tap that lands
   * nowhere because a new attribute was not added here is a defect this
   * project has already paid for once (3.5, the EPQ toggle). */
  const t=e.target.closest("[data-openfilters],[data-closefilters],[data-clearfilters],[data-vsort],[data-rmfilter],"+FILTER_DEFS.map(d=>"[data-v"+d.key+"]").join(","));
  if(!t)return;
  const prof=state.fCtx==="profile";
  const onProf=state.screen==="pubprofile";
  if("openfilters"in t.dataset){state.fCtx=t.dataset.openfilters||"vault";openFilters();return;}
  if("closefilters"in t.dataset){closeFilters();return;}
  if("clearfilters"in t.dataset){
    for(const def of FILTER_DEFS)state[onProf?def.p:def.v]="All";
    if(onProf){state.pSort="added";state.pSearch="";}
    else{state.vSort="added";state.vSearch="";}
    render();if($("filtersheet").classList.contains("open"))renderFilterSheet();return;}
  if("vsort"in t.dataset){if(prof)state.pSort=t.dataset.vsort;else state.vSort=t.dataset.vsort;render();renderFilterSheet();return;}
  for(const def of FILTER_DEFS){const k="v"+def.key;if(k in t.dataset){state[prof?def.p:def.v]=t.dataset[k];render();renderFilterSheet();return;}}
  if("rmfilter"in t.dataset){const k=t.dataset.rmfilter;
    const def=FILTER_DEFS.find(d=>d.key===k);
    if(def)state[onProf?def.p:def.v]="All";
    else if(k==="sort")state[onProf?"pSort":"vSort"]="added";
    render();return;}
});

export {
  SORTLABEL,
  backfillYears,
  /* ⚠ exported for `search-check` (stop C): the sheet's names are asserted
   * from the real sheet, and its twin can only reach a module it imports */
  renderFilterSheet,
  /* ⚠ re-exported: it now lives in `note-filters.js` so a gate can reach it */
  denomValue,
  frNum,
  noteYear,
}
